module.exports = __webpack_public_path__ + "static/placeholder-feature-2-ecf0d5e178e71b3ed2246ff5a4b32ca8.jpg";